import { useEffect, RefObject } from 'react'

export type CustomHandlerEvent = MouseEvent | TouchEvent

const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
    ref: RefObject<T>,
    handler: (event: CustomHandlerEvent) => void
): void => {
    useEffect(() => {
        const listener = (event: CustomHandlerEvent) => {
            const element = ref?.current
            if (!element || element.contains((event?.target as Node) || null)) {
                return
            }

            handler(event)
        }

        document.addEventListener('mousedown', listener)
        document.addEventListener('touchstart', listener)

        return () => {
            document.removeEventListener('mousedown', listener)
            document.removeEventListener('touchstart', listener)
        }
    }, [ref, handler])
}

export { useOnClickOutside }
